<template>
    <div ref="root" style="background-color:rgba(0, 0, 0, 0.5);" data-bs-backdrop="static" v-bind:class="{show : isvisible == true, displayblock : isvisible == true}" v-bind:id="'modal_' + getId()" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog" v-bind:class="size" role="document" style="background-color:transparent">
            <div class="modal-content" style="background-color:white;">
                <slot name="all"></slot>
                <div class="modal-header bg-primary">
                    <i @click="close()" class="icon-arrow-left8 mr-3 icon-2x d-md-none"></i> <h5 class="modal-title">{{title}}</h5>
                    <button type="button" class="close d-none d-md-block" @click="close()">&times;</button>
                </div>

                <div class="modal-body pb-0">
                    <slot name="main"></slot>
                </div>

                <div class="modal-footer pt-2 pb-1">
                    <button type="button" class="btn btn-link" @click="close()">Stäng</button>
                    <slot name="buttons"></slot>


                </div>
            </div>
        </div>
    </div>
</template>

<script>

    //import { ref, onMounted } from 'vue'
    import { ref } from 'vue'
    const root = ref(null)

    export default {

        name: 'common-modal',
        props: {
            title: {
              required: false,
              type: String,
              default: ""
            },
        },
        components:{
        },
        methods: {
            getId() {
                return this.$.uid;
            },
            open() {
                
                this.isvisible = true;
            },
            close() {
              this.isvisible = false;
            },
        },
        data() {
            return {
                isvisible: false,
            };
        },
        watch: {
        },
        mounted() {
            //$("#modal_" + this.getId()).modal({ backdrop: true });
            // eslint-disable-next-line
            $('body').append($(this.root.value).detach());
        },
        setup () {
            
            /*
            onMounted(() => {
                //alert("onMounted")
                // eslint-disable-next-line
                $("#modal_" + this.getId()).modal({ backdrop: true });
                // eslint-disable-next-line
                $('body').append($(root.value).detach());
                // the DOM element will be assigned to the ref after initial render
                console.log(root.value) // this is your $el
            })
            */
            return {
                root
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .displayblock {
        display: block;
    }
</style>
